import React, { Component } from 'react'
import Menu from './Menu'
import Content from './Content'
import { HeaderView } from '@merchant-backend/common-components'
import Store from './store'
import MainStore from './mainStore'
import { Provider } from 'mobx-react'
import { isSiDaTeam } from '@util'

export default class extends Component {
  constructor(props) {
    super(props)
    this.store = isSiDaTeam() ? new MainStore() : new Store()
  }

  componentDidMount() {
    this.store.getUnread()
  }

  render() {
    return (
      <Provider store={this.store}>
        <HeaderView contentStyle={{ display: 'flex', padding: 0 }}>
          <Menu />
          <Content />
        </HeaderView>
      </Provider>
    )
  }
}
